import { Order, OrderStatus, WorkStatus } from '../../types/order';
import { apiRequest } from '../../services/apiClient';

export interface OrderSummary {
  id: string;
  orderNo: string;
  customerName: string;
  phone: string;
  status: OrderStatus;
  workStatus: WorkStatus;
  workStartedAt: string | null;
  workCompletedAt: string | null;
  shape: string | null;
  quantity: number;
  boxSize: string | null;
  totalPrice: number | null;
  awaitingPayment?: boolean;
  createdAt: string;
}

function authHeaders(token: string): Record<string, string> {
  return { Authorization: `Bearer ${token}` };
}

export function fetchMyOrders(token: string): Promise<OrderSummary[]> {
  return apiRequest<OrderSummary[]>('/api/users/orders', { headers: authHeaders(token) });
}

export function fetchMyOrderDetail(orderId: string, token: string): Promise<Order> {
  return apiRequest<Order>(`/api/users/orders/${orderId}`, { headers: authHeaders(token) });
}
